import { mutations } from '../types';
import { $g } from '../../utils/global';
import { $storage } from '../../utils/storage';
export const mutation = {
    [mutations.layout.collapsed](state, status = null) {
        state.collapsed = status;
        $storage.set($g.caches.storages.collapsed, status);
    },
    [mutations.layout.opens](state, opens) {
        state.opens = Array.isArray(opens) ? opens : [opens];
    },
    [mutations.layout.active](state, active) {
        state.active = active;
    },
    [mutations.layout.drawer](state, status) {
        state.drawer = status;
    },
    [mutations.layout.mobile](state, status) {
        state.mobile = status;
    },
    [mutations.layout.type](state, type) {
        state.type = type;
    },
    [mutations.layout.routes](state, routes) {
        state.routes = routes;
        $storage.set($g.caches.storages.routes, JSON.stringify(routes));
    }
};
